var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scrollbar scrollbar--wide",attrs:{"id":"c-forms-layout"}},[_c(_setup.MsAjaxTemplate,{attrs:{"template-name":"build-canvas","ready-dependencies":_setup.readyDependencies}}),_vm._v(" "),_c('portal',{attrs:{"to":"canvas-description"}},[_vm._v(_vm._s(_setup.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }